const filterBar = document.querySelector('.Post__Grid__List__Detailed-filter-bar');

window.navigation = () => {
    return {
        scrolled: false,
        mobMenuOpen: false,
        megamenu: null,
        megaMenuOpen: false,
        activeSlideMegaMenu: null,
        activeSecondSlideMegaMenu: null,
        ipDetectionBar: false,
        image: null,
        filterBar: filterBar,

        init() {
            const ipDetectionBar = document.querySelector('.IP__Detection');

            if (typeof ipDetectionBar !== 'undefined' && ipDetectionBar !== null && ipDetectionBar.style.display !== 'none') {
                this.ipDetectionBar = true;
            }

            window.addEventListener('ipDetectionBarShow', e => {
                console.log(e);
                if (e.detail.show === true) {
                    this.ipDetectionBar = true;
                } else {
                    this.ipDetectionBar = false;
                }
            });
        },
        
        lockScroll() {
            const body = document.getElementsByTagName("body")[0];
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth; // Calculate scrollbar width
        
            body.style.overflow = 'hidden';
            body.style.paddingRight = `${scrollbarWidth}px`; // Add padding to offset the content shift
            document.querySelector('.body-overlay').style.display = 'block';
            document.querySelector('.body-overlay').classList.remove('hidden');
        },
        
        unlockScroll() {
            const body = document.getElementsByTagName("body")[0];
        
            body.style.overflow = 'auto';
            body.style.paddingRight = ''; // Remove the padding to restore normal layout
            document.querySelector('.body-overlay').style.display = 'none';
        },
        
        closeMegaMenu(e) {
            e.stopPropagation(); // Prevent event bubbling

            this.megamenu = null;
            this.megaMenuOpen = false;
            setTimeout(() => {
                this.activeSlideMegaMenu = null;
                this.activeSecondSlideMegaMenu = null;
            }, 300);
            this.$root.classList.remove('nav-open');
            this.unlockScroll();
        },
        toggleMegaMenu(menuItemID, e) {
            e.stopPropagation(); // Prevent event bubbling

            // Check if the menu is already open for this ID
            if (this.megamenu === menuItemID) {
                this.megamenu = null;
                this.megaMenuOpen = false;
                this.activeSlideMegaMenu = null;
                this.activeSecondSlideMegaMenu = null;
                this.$root.classList.remove('nav-open');
                this.unlockScroll();
            } else {
                this.megamenu = menuItemID;
                this.megaMenuOpen = true;
                this.activeSlideMegaMenu = null;
                this.activeSecondSlideMegaMenu = null;
                this.$root.classList.add('nav-open');
                this.lockScroll();
            }

        },
        openSlideMegaMenu(menuItemID, secondMenu = false) {
            this.activeSlideMegaMenu = menuItemID;
            if (secondMenu) {
                this.activeSecondSlideMegaMenu = true;
            }
        },
        closeSlideMegaMenu() {
            this.activeSlideMegaMenu = null;
        },
        openSecondSlideMegaMenu() {
            this.activeSecondSlideMegaMenu = true;
        },
        closeSecondSlideMegaMenu(secondMenu = false) {
            this.activeSecondSlideMegaMenu = null;
            if (secondMenu) {
                this.activeSlideMegaMenu = null;
            }
        }
    }
}
